import { mapActions, mapGetters, mapMutations } from 'vuex'
import dialogView from './dialog-view/index.vue'
import widgetsFilter from '../../components/widgets-filter/index.vue'
export default {
  name: 'setting-widgets',
  data () {
    return {
      page: 1,
      showRemoveDialog: false,
      removedItem: null
    }
  },
  components: {
    dialogView,
    widgetsFilter
  },
  computed: {
    ...mapGetters({
      list: 'settingWidgets/list',
      limit: 'settingWidgets/limit',
      listLength: 'settingWidgets/listLength',
      isLoading: 'settingWidgets/isLoading',
      isListLoading: 'settingWidgets/isListLoading',
      openDialogView: 'settingWidgets/openDialogView',
      basicCountries: 'setting/basicCountries'
    }),
    headers () {
      return [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Type',
          value: 'type'
        },
        {
          text: 'Status',
          value: 'status',
          sort: (a, b) => {
            const nameA = a.data.title.toLowerCase()
            const nameB = b.data.title.toLowerCase()
            if (nameA > nameB) {
              return -1
            }
            if (nameA < nameB) {
              return 1
            }
            return 0
          }
        },
        {
          text: 'Actions',
          sortable: false,
          value: 'actions'
        }
      ]
    }
  },
  created () {
    this.fetchList()
    if (!this.basicCountries.length) this.fetchBasicCountries()
  },
  methods: {
    ...mapActions({
      fetchList: 'settingWidgets/GET_LIST',
      remove: 'settingWidgets/DELETE',
      fetchBasicCountries: 'setting/GET_BASIC_COUNTRIES'
    }),
    ...mapMutations({
      changeSkip: 'settingWidgets/CHANGE_SKIP',
      changeDialogView: 'settingWidgets/CHANGE_DIALOG_VIEW',
      changeEditId: 'settingWidgets/CHANGE_EDIT_ID'
    }),
    changePagination (index) {
      this.changeSkip(this.limit * (index - 1))
      this.$vuetify.goTo(0)
      this.fetchList()
    },
    changeDialog (status = false, item = null) {
      this.changeEditId(item.id)
      this.changeDialogView(status)
    },
    changeDialogRemove (item) {
      this.showRemoveDialog = !!item
      this.removedItem = item
    },
    goToGuide () {
      this.$router.push({ name: 'setting.widgets.guide' })
    },
    removeListItem () {
      this.remove(this.removedItem).then(() => {
        this.showRemoveDialog = false
        this.$toasted.success(this.$t('success_deleted'))
      })
    }
  }
}
